<div [class]="clazz">
  @for (group of groups; track group) {
    <ea-group
      [group]="group"
      [options]="options"
      [context]="context"
    ></ea-group>
  }
</div>
